module.exports = __webpack_public_path__ + "static/media/mdi_.36bb978e.svg";